import React from "react";

// Custom UFO+Zombie logo (inline SVG) matching the requested cartoon style
export default function Logo({ size = 120 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="game-logo"
    >
      <defs>
        <radialGradient id="beamGrad" cx="50%" cy="0%" r="100%">
          <stop offset="0%" stopColor="#c2ff5d" stopOpacity="0.95" />
          <stop offset="60%" stopColor="#7ed957" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#7ed957" stopOpacity="0" />
        </radialGradient>
        <linearGradient id="domeGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#c2ff5d" />
          <stop offset="100%" stopColor="#3a9b1f" />
        </linearGradient>
        <linearGradient id="saucerGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#e0e4ec" />
          <stop offset="100%" stopColor="#7a808a" />
        </linearGradient>
      </defs>

      {/* Beam cone */}
      <path
        d="M 70 80 L 130 80 L 160 175 L 40 175 Z"
        fill="url(#beamGrad)"
        stroke="#7ed957"
        strokeOpacity="0.4"
        strokeWidth="1"
      />

      {/* Saucer bottom */}
      <ellipse cx="100" cy="80" rx="60" ry="14" fill="url(#saucerGrad)" stroke="#1a1a22" strokeWidth="3" />
      {/* Saucer rim */}
      <ellipse cx="100" cy="86" rx="55" ry="9" fill="#7a808a" stroke="#1a1a22" strokeWidth="2.5" />
      {/* Lights */}
      {[30, 55, 80, 105, 130, 155, 180].map((x, i) => (
        <circle key={i} cx={x + 4} cy="86" r="3" fill="#fff66b" stroke="#1a1a22" strokeWidth="1.2" />
      ))}
      {/* Dome */}
      <path
        d="M 70 75 Q 100 30 130 75 Z"
        fill="url(#domeGrad)"
        stroke="#1a1a22"
        strokeWidth="3"
      />
      <path
        d="M 80 70 Q 95 45 110 65"
        stroke="#ffffff"
        strokeOpacity="0.5"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
      />

      {/* Zombie head floating in beam */}
      <g transform="translate(100, 140)">
        <rect x="-18" y="-18" width="36" height="34" rx="3" fill="#7ed957" stroke="#1a1a22" strokeWidth="3" />
        {/* hair tufts */}
        <rect x="-16" y="-22" width="10" height="6" fill="#1a0e0e" />
        <rect x="6" y="-22" width="10" height="6" fill="#1a0e0e" />
        {/* eyes */}
        <circle cx="-7" cy="-5" r="5" fill="#ffffff" stroke="#1a1a22" strokeWidth="1.5" />
        <circle cx="8" cy="-5" r="5" fill="#ffffff" stroke="#1a1a22" strokeWidth="1.5" />
        <circle cx="-6" cy="-4" r="2.2" fill="#1a1a1a" />
        <circle cx="9" cy="-4" r="2.2" fill="#1a1a1a" />
        {/* mouth */}
        <rect x="-9" y="6" width="18" height="4" fill="#1a0a0a" />
        <rect x="-3" y="6" width="3" height="6" fill="#fff8d6" />
      </g>
    </svg>
  );
}
